export const CONSISTENCY_ACTIONS = {
  CANCEL: 'cancel',
  LISTING_ONLY: 'listingOnly',
  LISTING_AND_MASTER: 'listingAndMaster',
};

export const LISTING_MASTER_CONSISTENCY_DONT_SHOW_KEY = (
  'picsio.listingMasterConsistencyDontShow'
);
